import { stageMoveInit } from './move';
import { stageZoomInit } from './zoom';

function init(stageCube: CubeNode): void {
    stageMoveInit(stageCube);
    stageZoomInit();
}

export default {
    init
};
